module.exports = __webpack_public_path__ + "static/media/send-message-btn-mobile-left.cf77e376.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/send-message-btn-mobile-left.png
// module id = 574
// module chunks = 0